import React, { useState, useEffect, useContext } from 'react';
import { NetworkStatus, PlanService, InsuranceService } from '../../utils/types';
import { Autocomplete, TextField } from '@mui/material';
import { SectionHeader, SearchContainer, MobileBreakPoint } from '../../theme';
import { DataContext } from '../../containers/InsuranceChecker';
import { Container } from './styles';
import { isMobile } from 'react-device-detect';

type Props = {
    handleServiceSelect: (service: PlanService) => void;
    services: PlanService[] | undefined;
    orderMap: {[name: string]: number} | undefined;
}
const InsuranceServicesContainer = ({ handleServiceSelect, services, orderMap }:Props): JSX.Element => {
    const [ filteredServices, setFilteredServices ] = useState<InsuranceService[] | null>(null);
    const data = useContext(DataContext);
    const [ focus, setFocus ] = useState(isMobile || window.innerWidth <= MobileBreakPoint);

    useEffect(() => {
        if (!services || !orderMap) return;
        const filtered = services.filter(s => s.serviceStatus !== NetworkStatus.NotAvailable).map(s => s.name)
            .sort((a, b) => orderMap[a] - orderMap[b]);
        if (filtered.length === 1) {
            handleServiceSelect(services[0]);
        }
        setFilteredServices(data.services.filter(s => filtered.includes(s.name)));
    }, [ services, orderMap ]);

    const handleInputChange = (event:React.SyntheticEvent, value:string):void => {
        const selected = services?.find(s => s.name === value);
        if (selected) {
            handleServiceSelect(selected);
        }
    };
    if (!filteredServices) {
        return (<></>);
    }

    return (
        <SearchContainer>
            <Container style={{ height: focus ? '650px' : 'auto', padding: '15px' }}>
                <SectionHeader>What specialty would you like: Insurance coverage may vary depending on the service needed.</SectionHeader>
                <Autocomplete
                    disablePortal
                    id='service-select'
                    options={filteredServices}
                    autoComplete={true}
                    autoHighlight={true}
                    onInputChange={handleInputChange}
                    onFocus={() => { setFocus(true); }}
                    onBlur={() => { setFocus(false); }}
                    open={focus}
                    renderInput={(params) => <TextField {...params} placeholder='Search by specialty'/>}
                    renderOption={(props, option: InsuranceService) => (
                        <li key={option._id} {...props}><p style={{ margin: '0px' }}><strong style={{ fontWeight: '700' }}>{option.name}{ isMobile ? ' - ' : ': ' } </strong> {option.definition}</p></li>
                    )}
                    ListboxProps={{ sx: { maxHeight: isMobile ? '450px' : '40vh' } }}
                    componentsProps={{ popper: { placement: 'bottom-start', sx: { height: '50%' } } }}
                    sx={{
                        borderRadius: focus ? '10px 10px 0px 0px' : '10px',
                        boxShadow: 'none',
                    }}
                    getOptionLabel={(option: InsuranceService):string => { return option.name; }}
                />
            </Container>
        </SearchContainer>
    );
};

export default InsuranceServicesContainer;
